module.exports = __webpack_public_path__ + "static/7plus_wellness-883b666004e66989e68e44ebd6512db4.png";